/* ita-card.js: product card photo swaps.
   1. Colour chips: hover (mouse) or tap a chip and the card photo switches to that colour's variant image (when the variant has one).
   2. Hover photo: the second photo (back / model / picked card photo) is loaded and decoded while the card is on screen, so the
      hover swap is instant and never flashes. The tile box itself is locked in ita-card.css, so a photo of another size
      can never resize the tile.
   Idempotent: the snippet prints this tag per card, it only binds once. */
(function () {
  if (window.__itaCardSw) return; window.__itaCardSw = 1;
  var doc = document;

  /* ---------- hover photo: warm it up before it is needed ---------- */
  var HOVER_SEL = '.m-b img,.m-mod img,.m-ov img';
  function warm(card) {
    if (!card || card.__itaWarm) return; card.__itaWarm = 1;
    var list = card.querySelectorAll(HOVER_SEL);
    for (var i = 0; i < list.length; i++) {
      var im = list[i];
      if (im.getAttribute('loading') === 'lazy') { im.setAttribute('loading', 'eager'); im.loading = 'eager'; }
      im.setAttribute('fetchpriority', 'low');
      if (im.decode) { try { im.decode().catch(function () {}); } catch (e) {} }
    }
  }
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (es[i].isIntersecting) { warm(es[i].target); io.unobserve(es[i].target); }
      }
    }, { rootMargin: '300px 300px' });
  }
  function scan(root) {
    var cards = (root || doc).querySelectorAll ? (root || doc).querySelectorAll('.m-card') : [];
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].__itaSeen) continue; cards[i].__itaSeen = 1;
      if (io) { io.observe(cards[i]); } else { warm(cards[i]); }
    }
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', function () { scan(doc); }); } else { scan(doc); }
  window.addEventListener('load', function () { scan(doc); });
  doc.addEventListener('shopify:section:load', function (e) { scan(e.target || doc); });
  /* a card the mouse reaches before it was warmed (rails scroll sideways) */
  doc.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var c = e.target.closest && e.target.closest('.m-card'); if (c) warm(c);
  }, true);

  /* ---------- colour chips ---------- */
  function paint(im, src) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = src; }
  function swap(chip, on) {
    var card = chip.closest('.m-card'); if (!card) return;
    var im = card.querySelector('.m-a img'); if (!im) return;
    if (!im.dataset.o) { im.dataset.o = im.currentSrc || im.src; im.dataset.os = im.getAttribute('srcset') || ''; im.dataset.oz = im.getAttribute('sizes') || ''; }
    card.querySelectorAll('.m-sw i.on').forEach(function (x) { x.classList.remove('on'); });
    var src = chip.getAttribute('data-img');
    var token = (im.__itaTok = (im.__itaTok || 0) + 1);
    card.classList.toggle('m-swon', !!(on && src));
    /* the picked colour is remembered on the card even when that colour has no own photo (quick add reads it: .m-sw i.on) */
    if (on) chip.classList.add('on');
    /* owner 2026-10-29: the product link follows the shown colour (chip data-vid = first variant of that colour) */
    (function () { var vid = chip.getAttribute('data-vid'); card.querySelectorAll('a.m-lk, a.m-nmlk').forEach(function (a) { var base = a.getAttribute('href').split('?')[0]; a.setAttribute('href', on && vid ? base + '?variant=' + vid : base); }); })();
    /* flat lay cards: the chip also carries that colour's hover photo (floor flat lay), so main and hover always stay one colour */
    var hi = card.querySelector('.m-b img'), hsrc = chip.getAttribute('data-hov');
    /* Mesozoic 2026-11-02 (hover glitch): the hover photo is the first colour's photo. When a chip changes the main photo to THAT colour, main and hover were the same picture and the
       hover did nothing ("it tries to hover and change, but it doesn't"). While a colour is shown, the hover photo is another colour's photo. */
    if (on && src && !hsrc) {
      var alt = [].slice.call(card.querySelectorAll('.m-sw i[data-img]')).map(function (i) { return i.getAttribute('data-img'); }).filter(function (u) { return u && u !== src; })[0];
      if (alt) hsrc = alt;
    }
    if (hi) {
      if (!hi.dataset.o) { hi.dataset.o = hi.currentSrc || hi.src; hi.dataset.os = hi.getAttribute('srcset') || ''; hi.dataset.oz = hi.getAttribute('sizes') || ''; }
      if (on && hsrc) paint(hi, hsrc);
      else { if (hi.dataset.os) hi.setAttribute('srcset', hi.dataset.os); if (hi.dataset.oz) hi.setAttribute('sizes', hi.dataset.oz); hi.src = hi.dataset.o; }
    }
    if (on && src) {
      /* decode the colour's photo first, then show it: no blank frame, no flash */
      var pre = new Image();
      var apply = function () { if (im.__itaTok === token) paint(im, src); };
      pre.src = src;
      if (pre.decode) { pre.decode().then(apply).catch(apply); }
      else if (pre.complete) { apply(); }
      else { pre.onload = apply; pre.onerror = apply; }
    } else {
      if (im.dataset.os) im.setAttribute('srcset', im.dataset.os);
      if (im.dataset.oz) im.setAttribute('sizes', im.dataset.oz);
      im.src = im.dataset.o;
    }
  }
  /* owner 2026-10-30 (pick C2): chips on a computer swap the photo only after the pointer RESTS on a chip for 150 ms (passing over chips on the
     way somewhere does nothing), the photo cross-fades in over .2 s, and the chosen colour STAYS when the pointer leaves the chip: it goes back
     (or to the pinned colour) only when the mouse leaves the card. Touch / pen: unchanged (tap = pin, handled by the click handler below). */
  var CHIP_INTENT = 150, CHIP_FADE = 200;
  var reduceMo = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function chipFade(chip, on) {
    var card = chip.closest('.m-card'), im = card && card.querySelector('.m-a img'), tile = im && im.closest('.m-tile');
    if (!tile || reduceMo.matches) { swap(chip, on); return; }
    if (!im.dataset.o) { im.dataset.o = im.currentSrc || im.src; }
    var target = on ? chip.getAttribute('data-img') : im.dataset.o;
    if (!target) { swap(chip, on); return; }
    var old = tile.querySelector('.m-cf'); if (old) old.remove();
    var tr = tile.getBoundingClientRect(), ir = im.getBoundingClientRect();
    var ov = new Image(); ov.className = 'm-cf'; ov.alt = ''; ov.decoding = 'async';
    ov.style.cssText = 'left:' + (ir.left - tr.left) + 'px;top:' + (ir.top - tr.top) + 'px;width:' + ir.width + 'px;height:' + ir.height + 'px';
    var tok = (card.__itaFade = (card.__itaFade || 0) + 1);
    var go = function () {
      if (card.__itaFade !== tok) { ov.remove(); return; }
      tile.appendChild(ov);
      void ov.offsetWidth; ov.classList.add('on');
      setTimeout(function () {
        if (card.__itaFade !== tok) { ov.remove(); return; }
        swap(chip, on);
        setTimeout(function () { if (card.__itaFade === tok) ov.remove(); }, 120);
      }, CHIP_FADE + 30);
    };
    ov.src = target;
    if (ov.decode) { ov.decode().then(go, go); } else if (ov.complete) { go(); } else { ov.onload = go; ov.onerror = go; }
  }
  function chipLeave(card) {
    clearTimeout(card.__itaCT);
    var shown = card.querySelector('.m-sw i.on'), pin = card.getAttribute('data-pin');
    if (pin) { var pc = chipByTitle(card, pin); if (pc && pc !== shown) chipFade(pc, true); return; }
    if (shown && card.classList.contains('m-swon')) chipFade(shown, false);
  }
  doc.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return; var c = e.target.closest && e.target.closest('.m-sw i'); if (!c) return;
    if (c.contains(e.relatedTarget)) return;
    var card = c.closest('.m-card'); if (!card) return;
    clearTimeout(card.__itaCT);
    if (c.classList.contains('on') && card.classList.contains('m-swon')) return;
    card.__itaCT = setTimeout(function () { chipFade(c, true); }, CHIP_INTENT);
  });
  doc.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var c = e.target.closest && e.target.closest('.m-sw i');
    if (c && !c.contains(e.relatedTarget)) { var cc = c.closest('.m-card'); if (cc) clearTimeout(cc.__itaCT); }
    var card = e.target.closest && e.target.closest('.m-card');
    if (card && !card.contains(e.relatedTarget)) chipLeave(card);
  });
  /* a tapped / clicked chip is PINNED on the card (data-pin = colour name): the photo stays on it, hover only previews, and quick add opens with it */
  function chipByTitle(card, t) { return [].slice.call(card.querySelectorAll('.m-sw i')).filter(function (x) { return (x.getAttribute('title') || '') === t; })[0] || null; }
  function repin(card) { var t = card && card.getAttribute('data-pin'); if (!t) return; var pc = chipByTitle(card, t); if (pc) swap(pc, true); }
  /* owner 2026-10-29: a card with a pinned colour (ita.card_colour) starts on that colour: its chip is marked and quick add uses it */
  function pinAll() { [].slice.call(document.querySelectorAll('.m-card[data-pin]')).forEach(function (c) { if (c.querySelector('.m-sw i.on')) return; var pc = chipByTitle(c, c.getAttribute('data-pin')); if (pc) pc.classList.add('on'); }); } /* mark only: the main photo already is that colour (Liquid); swap mode would block the hover reveal */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinAll); else pinAll();
  document.addEventListener('shopify:section:load', pinAll);
  /* colour filter on a collection: every card shows the photo of the filtered colour (owner 2026-10-28: filtering White kept black photos).
     Reads the colour filter values from the page URL (filter.v.option.color / colour); several colours = the first one the card has. */
  function filterColours() {
    var out = []; try { new URLSearchParams(location.search).forEach(function (v, k) { if (/^filter\.v\.option\.colou?r$/i.test(k)) out.push(v.toLowerCase()); }); } catch (e) {}
    return out;
  }
  window.ITA_cardColour = function (root) {
    var want = filterColours();
    (root || doc).querySelectorAll('.m-card').forEach(function (card) {
      var chips = [].slice.call(card.querySelectorAll('.m-sw i[data-img]'));
      var hit = null;
      for (var i = 0; i < want.length && !hit; i++) hit = chips.filter(function (c) { return (c.getAttribute('title') || '').toLowerCase() === want[i]; })[0] || null;
      /* Mesozoic 2026-11-02: AU "-1" listings say "Faded Black" where US / EU say "Black": no exact hit = match with "faded " ignored */
      var fz = function (x) { return String(x || '').toLowerCase().replace(/^\s*faded\s+/, '').trim(); };
      for (var j = 0; j < want.length && !hit; j++) hit = chips.filter(function (c) { return fz(c.getAttribute('title')) === fz(want[j]); })[0] || null;
      if (hit) { swap(hit, true); card.setAttribute('data-pin', hit.getAttribute('title') || ''); card.setAttribute('data-pinf', '1'); }
      else if (card.hasAttribute('data-pinf')) { card.removeAttribute('data-pinf'); card.removeAttribute('data-pin'); var on = card.querySelector('.m-sw i.on'); if (on) swap(on, false); }
      else if (card.classList.contains('m-swon') && !card.hasAttribute('data-pin')) { var on2 = card.querySelector('.m-sw i.on'); if (on2) swap(on2, false); }
    });
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { window.ITA_cardColour(); }); else window.ITA_cardColour();
  doc.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('.m-sw i'); if (!c) return;
    e.preventDefault(); e.stopPropagation();
    var card = c.closest('.m-card'), t = c.getAttribute('title') || '';
    clearTimeout(card.__itaCT); card.__itaFade = (card.__itaFade || 0) + 1; var cf = card.querySelector('.m-cf'); if (cf) cf.remove();
    if (card.getAttribute('data-pin') === t) { card.removeAttribute('data-pin'); card.removeAttribute('data-pinf'); swap(c, false); }
    else { card.setAttribute('data-pin', t); card.removeAttribute('data-pinf'); swap(c, true); }
  }, true);
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return; var c = e.target.closest && e.target.closest('.m-sw i'); if (!c) return;
    e.preventDefault(); c.click();
  });
})();
